/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'reactstrap';
import usePageTitle from '../../common/hooks/usePageTitle';
import Breadcrumbs from '../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import Filters from '../../components/Common/Filters/filters';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getDynamicAttrUpdated, transformCFColumnsData } from '../../helpers/tools_helper';
import { getEntitiesList } from '../../store/Entities/actions';
import { getNameClient } from './../../helpers/nameClient';
import IForm from './FormEntities';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';
const Entities = (props: any) => {
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [title, setTitle] = useState('');
    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });
    const groupName = 'EntitiesDataViewList';
    //Store------

    const { EntitiesData, lengthEntities, milestoneConfig, isLoading } = useSelector((state: any) => {
        return {
            EntitiesData: state.Entities.EntitiesList,
            lengthEntities: state.Entities.lengthEntities,
            milestoneConfig: state.Entities.milestoneConfig,
            isLoading: state.Entities.isLoading,
        };
    });
    //-------

    const PageTitleIEN = usePageTitle(props.location.pathname);

    const [form, setForm] = useState({
        order: "{'name' : 'DESC'}",
        dynamicFilter: '',
    });

    const [isPageLoading, setIsPageLoading] = useState(true);

    const [entitiesList, setEntitiesList] = useState<any[]>([]);
    const [tableConfig, setTableConfig] = useState([]);
    const [isFirstRun, setIsFirstRun] = useState(true);

    const dispatch = useDispatch();

    const processList = (list: any[], selectedRow: any) => {
        const t: any[] = [];
        for (const item in selectedRow) {
            list.map(function (data: { dataField: string }, index: any) {
                if (data.dataField === item)
                    t.push({
                        ...data,
                        value: selectedRow[item],
                    });
                return data;
            });
        }
        return t;
    };

    useEffect(() => {
        if (isFirstRun) {
          const filters = JSON.parse(localStorage.getItem("filterOperation") || "{}");
          if (filters[groupName]) {
            handleActionOnSearch(filters[groupName]);
          }
          setIsFirstRun(false);
        } else {
          dispatch(getEntitiesList({ form, pagination }));
        }
      }, [dispatch, form, pagination, isFirstRun]);
      

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(EntitiesData);
        setEntitiesList(listFinal);
        setIsPageLoading(false);
    }, [EntitiesData]);

    useEffect(() => {
        setIsPageLoading(isLoading);
    }, [isLoading]);

    useEffect(() => {
        const dataSorted = milestoneConfig.sort(function (a: any, b: any) {
            const x = a.order;
            const y = b.order;
            //compare the word which is comes first
            if (x > y) {
                return 1;
            }
            if (x < y) {
                return -1;
            }
            return 0;
        });
        dataSorted.forEach((milestone: any) => {
            milestone.hidden = !milestone.visibleInTable;
        });
        setTableConfig(dataSorted);
    }, [milestoneConfig]);


    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        const newForm = { ...data, dynamicFilter: filterString };
        setForm(newForm);
    };

    const handleActionOnRowClick = (row: any) => {
        const visibleInModalFooter = milestoneConfig.filter((x: { visibleInModalFooter: boolean }) => x.visibleInModalFooter === true);
        let titleArr = processList(visibleInModalFooter, row);
        titleArr = titleArr.map((x) => {
            return x.value;
        });
        setTitle(titleArr.join(' - '));
        setSelectedRow(row);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type :any, { sortField, sortOrder }:any) => {
        setForm( {...form,
            order: `{'${sortField ?? 'name'}' : '${sortOrder.toUpperCase()}'}` 
        })
    }

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <PageTitle>
                    <title>Entities | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <Row>
                        <Filters onSearchClicked={handleActionOnSearch} filterItems={milestoneConfig} groupName={groupName} hideDates />
                    </Row>
                    <Row>
                        <div className="container-sm">
                            <Iloading  loading={isLoading}/>
                        </div>
                        {entitiesList.length > 0 ? (
                            milestoneConfig.length === 0 ? (
                                <>
                                    <div>No config operations for this table</div>
                                </>
                            ) : (
                                <>
                                    <ITable
                                        remote={true}
                                        CountItems={lengthEntities}
                                        handlerPaginationState={handlePaginationChange}
                                        data={entitiesList}
                                        fields={milestoneConfig}
                                        tableColumns={milestoneConfig}
                                        headerColorT={'bg-primary text-white'}
                                        groupName={groupName}
                                        handlePopUpState={onPopUpState}
                                        actionOnRowClick={handleActionOnRowClick}
                                        handleTableSort={handleTableSort}
                                    />
                                </>
                            )
                        ) : null}
                    </Row>
                </Container>
            </div>

            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Entities'}
                icon="shopping-bag"
                colorHeaderPop={'#101340'}
            >
                <IForm selectedRow={selectedRow} milestoneConfig={tableConfig} groupName={groupName} />
            </IPopUp>
        </React.Fragment>
    );
};

export default Entities;
